import { AfterViewInit, Component, ElementRef, OnChanges, OnInit, SimpleChanges, output, viewChild, input, inject } from '@angular/core';

import { ApButtonComponent } from '@ap/button';
import { ApContentService } from '@ap/content';

import content from './suggestion.content.json';

@Component({
    selector: 'ap-suggestion',
    templateUrl: './suggestion.component.html',
    imports: [ApButtonComponent]
})
export class ApSuggestionComponent implements OnInit, AfterViewInit, OnChanges {
    readonly contentService = inject(ApContentService);

    protected readonly textButton = viewChild('textButton', { read: ElementRef });

    // eslint-disable-next-line @angular-eslint/no-output-on-prefix
    public readonly onClick = output<Event>();

    public readonly suggestion = input<string>(undefined);

    protected textBefore: string;
    protected textClick: string;
    protected textAfter: string;

    private button: HTMLButtonElement;

    public ngOnInit() {
        this.initText();
        this.setText();
    }

    public ngAfterViewInit() {
        this.button = this.textButton().nativeElement.querySelector('button');
    }

    public ngOnChanges(changes: SimpleChanges) {
        if (changes['suggestion'] !== undefined) {
            this.setText();
        }
    }

    protected onTextClick() {
        this.onClick.emit(undefined);
    }

    private initText() {
        this.contentService.addContentItems(content);
        this.textClick = this.contentService.get('click');
        this.textAfter = this.contentService.get('after');
    }

    private setText() {
        const { suggestion: suggestionInput } = this;
        const suggestion = suggestionInput();
        this.textBefore = this.contentService.get('before', { suggestion });
        requestAnimationFrame(() => {
            this.button.focus();
        });
    }

    protected get ariaLabel() {
        const html = `${this.textBefore} ${this.textClick} ${this.textAfter}`;
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        return doc.body.textContent || '';
    }
}
